import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import PagersTable from '../reporting/PagersTable';
import { Form, Row, Col, Button } from '../ui-kit';
import { operations as pagerTemplateOperations } from '../../state/modules/pager-templates';
import { selectors as pagerTemplateSelectors } from '../../state/modules/pager-templates';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PagerBulkTemplateApplyForm = ({ groupId, pagers, pagerTemplates, fetchPagerTemplates, applyPagerTemplate }) => {
  const [selectedTemplateId, setSelectedTemplateId] = useState(0);
  const [selectedPagerIds, setSelectedPagerIds] = useState([]);
  useEffect(() => fetchPagerTemplates({ params: { group_id: groupId, presentation_type: 'full' } }), []);

  // when pager templates load for the first time, select the first
  useEffect(() => {
    if (!selectedTemplateId) setSelectedTemplateId(pagerTemplates[0]?.id);
  }, [pagerTemplates]);

  const selectedTemplate = pagerTemplates.find(t => t.id === selectedTemplateId);
  const applicablePagers = pagers.filter(p => (selectedTemplate?.applicable_pager_ids || []).includes(p.id));

  const onSelectChange = useCallback(
    (ids, selected) => {
      if (selected) {
        setSelectedPagerIds([...ids, ...selectedPagerIds]);
      } else {
        setSelectedPagerIds(selectedPagerIds.filter(i => !ids.includes(i)));
      }
    },
    [selectedPagerIds]
  );

  const i18n = I18n.t('activemodel.attributes.mobile/pagers/swissphone_pager_configuration');
  const applyTemplate = () => {
    applyPagerTemplate(selectedTemplateId, selectedPagerIds).then(() => {
      toast.info(i18n.messages.template_success, {
        position: 'top-center',
        autoClose: 3000,
        closeOnClick: false
      });
      toast();
      setSelectedPagerIds([]);
    });
  };

  const form = (
    <Form>
      <Form.Group as={Row} className="mb-3">
        <Form.Label column sm={2}>
          {I18n.t('pager.template')}
        </Form.Label>
        <Col sm={6}>
          <Form.Select value={selectedTemplateId} onChange={e => setSelectedTemplateId(Number(e.target.value))}>
            {pagerTemplates.map(template => (
              <option key={template.id} value={template.id || ''}>
                {template.name}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col sm={4}>
          <Button variant="success" onClick={applyTemplate} disabled={selectedPagerIds.length === 0}>
            {I18n.t('apply')}
          </Button>
        </Col>
      </Form.Group>
    </Form>
  );

  return (
    <>
      <ToastContainer />
      {form}
      <PagersTable pagers={applicablePagers} selectable onSelectChange={onSelectChange} selected={selectedPagerIds} />
    </>
  );
};

const mapStateToProps = state => ({
  pagerTemplates: pagerTemplateSelectors.values(state)
});

const mapDispatchToProps = {
  fetchPagerTemplates: pagerTemplateOperations.fetch,
  applyPagerTemplate: pagerTemplateOperations.applyTemplate
};

export default connect(mapStateToProps, mapDispatchToProps)(PagerBulkTemplateApplyForm);
